import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useDonate } from "../context/DonateContext";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Mission", href: "#mission" },
  { label: "Programs", href: "#programs" },
  { label: "Vision", href: "#vision" },
  { label: "Partners", href: "#partners" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { open: openDonate } = useDonate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F4F1EB]/85 backdrop-blur-xl border-b border-[#E2DCD0]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-4 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3 group">
          <img
            src="/assets/logo.png"
            alt="Guardian Grace Foundation"
            className="h-12 w-12 object-contain rounded-full ring-1 ring-[#E2DCD0] bg-[#FAF8F5]"
          />
          <div className="hidden sm:block leading-tight">
            <div className="font-serif text-lg text-[#692128] font-semibold">
              Guardian Grace
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#5C5856]">
              Family &amp; Community Foundation
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-[#2C2A29]/80 hover:text-[#692128] transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#donate"
            onClick={(e) => {
              e.preventDefault();
              openDonate();
            }}
            data-testid="header-donate-btn"
            className="hidden sm:inline-flex items-center bg-[#692128] text-[#F4F1EB] hover:bg-[#8B2635] rounded-full px-6 py-2.5 text-sm font-medium tracking-wide transition-all duration-300"
          >
            Donate
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 text-[#2C2A29]"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF8F5] border-t border-[#E2DCD0]" data-testid="mobile-menu">
          <nav className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-[#2C2A29] hover:text-[#692128]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#donate"
              onClick={(e) => {
                e.preventDefault();
                setOpen(false);
                openDonate();
              }}
              data-testid="mobile-donate-btn"
              className="mt-2 inline-flex justify-center bg-[#692128] text-[#F4F1EB] rounded-full px-6 py-3 text-sm font-medium"
            >
              Donate
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
